import React, {useEffect, useState, useCallback} from 'react';
import {Button, Col} from "antd";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {useDG_FormContext} from "../../custom/data-entry/form";
import {useNavigate} from "react-router-dom";
import {onReloadData} from "../../redux/actions/layout/interaction/action";
import {debounce} from "lodash/function";
import {DELAY_DEBOUNCE} from "../config-variable/notification";

const DG_Submit = props => {

    const {t} = useTranslation();

    const dispatch = useDispatch()

    let navigate = useNavigate();

    const {mode, form, success, onChangeSuccess} = useDG_FormContext()
    const [onClick, setOnClick] = useState(false)

    useEffect(() => {

        if (onClick && success && (props?.skipLoading === undefined || props?.skipLoading === false)) {
            if (mode === "add")
                form?.resetFields()
            onChangeSuccess()
            dispatch(onReloadData(true))
            navigate(-1)
        }
    }, [success, onClick])

    const debouncedAdd = useCallback(
        debounce((form) => {
            form.submit()
        }, DELAY_DEBOUNCE),
        []);

    const handleAdd = () => {
        setOnClick(true)
        debouncedAdd(form)
    };

    return (
        <Col className={"ml-3"}>
            <Button
                loading={props?.loading}
                onClick={handleAdd}
                {...props}
                type="primary"
                style={{fontWeight: 600, fontSize: '14px'}}
            >
                {t(`common.${mode}`)}
            </Button>
        </Col>
    );
};

DG_Submit.propTypes = {};

export default DG_Submit;
